import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';

export class PhasrRecommendationSideMenuBaseDataProvider extends BaseWebComponentDataProvider {
  public async getRecommendation(recommendationId: string): Promise<any> {
    //todo this is left as empty for when PHASR API supports this operation
    return [];
  }
}
